// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const registerUserPagoMovilDataService = async (data: Record<string, unknown>) => {
  const url = `${ConfEnv.BASE_URL}/user/profile`;

  return privateRequest.put(url, data);
};
